export default "/_next/static/images/photo-banner-desktop-5b3b937c118588d4a17deafaf251fef0.png";